import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { Observable, distinctUntilChanged, map, tap } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  selectCoreLanguage,
  selectMainMenuCanToggle,
  selectMainMenuExpanded,
  selectMainMenuItems,
  selectMainMenuSecondaryItems,
} from '../../reducers';
import {
  toggleHeaderExpand,
  toggleMainMenuExpanded,
} from '../../actions/main-menu.actions';

import { AppState } from 'src/app/reducers';
import { LoggerService } from '@services/logger.service';
import { MenuItem } from "src/app/core/models/main-menu.models";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    standalone: false
})
export class MainMenuComponent implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef;

  isExpanded$: Observable<boolean>;
  menuItems$: Observable<Array<MenuItem>>;
  mainMenuCanToggle$: Observable<boolean>;
  menuItemsSecondary$: Observable<Array<MenuItem>>;

  isRtl: boolean = false;
  hasUser: boolean = true;
  searchString: string = '';
  filtered: boolean = false;
  searchEnabled: boolean = false;
  hasBackButton: boolean = false;

  @Output() onBackClick: EventEmitter<any> = new EventEmitter();

  private destroyRef = inject(DestroyRef);

  constructor(
    private store: Store<AppState>,
    private router: Router,
    public route: ActivatedRoute,
    private logger: LoggerService,
  ) {
    this.isExpanded$ = this.store.select(selectMainMenuExpanded);
    this.menuItems$ = this.store.select(selectMainMenuItems);
    this.menuItemsSecondary$ = this.store.select(selectMainMenuSecondaryItems);
    this.mainMenuCanToggle$ = this.store.select(selectMainMenuCanToggle);
    this.store
      .pipe(
        // grab the language from the store
        select(selectCoreLanguage),
        // derive an RTL flag based on the language ID
        map((language) => language.id === 6),
        // only update when the flag actually changes
        distinctUntilChanged(),
        // side-effect: update the component property
        tap((isRtl) => (this.isRtl = isRtl)),
        // automatically unsubscribe on destroy
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  ngOnInit() {
    this.router.events
      .pipe(
        tap(() => {
          this.markActiveMenuItem();
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  toggleMenuHeader(menuItem: MenuItem) {
    if (menuItem.isHeader && menuItem.isHeader == true) {
      this.store.dispatch(toggleHeaderExpand({ menuItem }));
    }
  }

  toggleSidebar() {
    this.store.dispatch(toggleMainMenuExpanded());

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  back() {
    this.onBackClick.emit(true);
  }

  toggleSearch() {
    this.searchEnabled = !this.searchEnabled;
    if (!this.searchEnabled) {
      this.searchString = '';
    }
  }

  onSearchChange(value: any) {
    if (typeof value === 'string') {
      this.searchString = value;
    }
  }

  itemClick(item: MenuItem) {
    if (item.link) {
      this.router.navigate([item.link]);
    }
  }

  markActiveMenuItem() {}

  searchChange() {}
}
